const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const FUT_WS_URL = "wss://fx-ws.gateio.ws/v4/ws/usdt";

const toSec = (x) => (x > 2e10 ? Math.floor(x / 1000) : Number(x));
const toLwc = (t, o, h, l, c) => ({
  time: t,
  open: Number.isFinite(+o) ? +o : undefined,
  high: Number.isFinite(+h) ? +h : undefined,
  low:  Number.isFinite(+l) ? +l : undefined,
  close:Number.isFinite(+c) ? +c : undefined,
});

export async function gateFuturesFetchHistory({ symbol, interval, limit = 300, settle = "usdt" }) {
  const url = `${PROXY}/https://api.gateio.ws/api/v4/futures/${settle}/candlesticks?contract=${encodeURIComponent(symbol)}&interval=${encodeURIComponent(interval)}&limit=${limit}`;
  // const r = await fetch(url);
  const r = await fetch(url, {
    headers: {
      'ngrok-skip-browser-warning': 'true',
    },
  });
  if (!r.ok) throw new Error(`Gate FUT HTTP ${r.status}`);
  const rows = await r.json();
  const out = rows
    // resp: [{ t, v, c, h, l, o, sum }]
    .map(a => toLwc(toSec(+a.t), +a.o, +a.h, +a.l, +a.c))
    .sort((x, y) => x.time - y.time)
    .slice(-limit);
  return out;
}

export function gateFuturesOpenWS({ symbol, interval, onBars }) {
  const ws = new WebSocket(FUT_WS_URL);
  let opened = false;

  const close = () => {
    try {
      if (opened && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
          time: Date.now(),
          channel: "futures.candlesticks",
          event: "unsubscribe",
          payload: [interval, symbol],
        }));
      }
    } catch {}
    try { ws.close(); } catch {}
  };

  ws.onopen = () => {
    opened = true;
    ws.send(JSON.stringify({
      time: Date.now(),
      channel: "futures.candlesticks",
      event: "subscribe",
      payload: [interval, symbol],
    }));
  };

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data);
      if (msg.channel !== "futures.candlesticks" || msg.event !== "update") return;
      const arr = Array.isArray(msg.result) ? msg.result : [];
      const bars = arr.map(r => toLwc(toSec(+r.t), +r.o, +r.h, +r.l, +r.c));
      if (bars.length) onBars?.(bars);
    } catch {}
  };

  return close;
}
